document.querySelectorAll('[data-lopeta-product]').forEach((root) => {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const mainImage = root.querySelector('.lu-product-image');
  const variantSelect = root.querySelector('[data-lopeta-variant]');
  const form = root.querySelector('.lu-product-form');
  const setImage = (src, alt) => {
    if (!mainImage || !src) return;
    mainImage.removeAttribute('srcset');
    mainImage.src = src;
    if (alt) mainImage.alt = alt;
  };
  root.querySelectorAll('[data-lopeta-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', (event) => {
      event.preventDefault();
      setImage(thumb.dataset.imageSrc, thumb.dataset.imageAlt);
      root.querySelectorAll('[data-lopeta-thumb]').forEach((item) => item.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
    });
  });
  variantSelect?.addEventListener('change', () => {
    const option = variantSelect.selectedOptions[0];
    root.querySelectorAll('[data-lopeta-price]').forEach((price) => { price.textContent = option.dataset.price; });
    root.querySelectorAll('[data-lopeta-add]').forEach((button) => {
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.readyLabel;
    });
    setImage(option.dataset.image);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
  const sticky = root.querySelector('[data-lopeta-sticky]');
  if (sticky && form && 'IntersectionObserver' in window) new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: 0 }).observe(form);
});
document.querySelectorAll('.lu-menu').forEach((menu) => {
  menu.addEventListener('keydown', (event) => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  document.addEventListener('click', (event) => { if (!menu.contains(event.target)) menu.open = false; });
});
